import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import CalendarView from "@/components/CalendarView";
import { Loader2, CalendarDays } from "lucide-react";

export default function PlayerCalendar() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/bookings/calendar").then(r => { setItems(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const handleItemClick = (item) => {
    if (item.type === "booking") navigate("/bookings");
    else if (item.type === "event") navigate(`/events/${item.id}`);
    else if (item.type === "session") navigate(`/coach/sessions/${item.id}`);
  };

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-court-orange" /></div>;

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 md:py-10" data-testid="player-calendar-page">
      <h1 className="font-heading text-3xl md:text-4xl font-bold uppercase tracking-tight flex items-center gap-3 mb-6">
        <CalendarDays className="w-8 h-8 text-court-orange" />My Calendar
      </h1>
      <CalendarView items={items} onItemClick={handleItemClick} title="My Calendar" />
    </div>
  );
}
